<template>
    <v-container fluid fill-height :class="ranking_data ? 'ranking-content' : ''">
        <v-row class="ma-12" justify="center" v-if="ranking_data && rankingMode">
            <TopThree
                :first="dataForToShow[0]"
                :second="dataForToShow[1]"
                :third="dataForToShow[2]"
            />
            <RankingTable v-if="ranking_data" :list_data="dataForToShow.slice(3)" />
        </v-row>
    </v-container>
</template>
<script>
import { mapState } from 'vuex'

import TopThree from './TopThree.vue'
import RankingTable from './RankingTable.vue'

export default {
    components: {
        TopThree,
        RankingTable,
    },
    props: {
        ranking_data: {
            type: Object,
            default: null,
        },
    },
    computed: {
        ...mapState({
            rankingMode: (state) => state.rankingMode,
        }),
        dataForToShow() {
            if (this.rankingMode === 'school') return this.ranking_data.schoolList
            return this.ranking_data.globalList
        },
    },
}
</script>

<style>
.ranking-content {
    background: linear-gradient(180deg, #ffffff 0%, #c6e7e3 52.97%, #508682 100%);
}
</style>
